<p-table [value]="venueVisits" styleClass="p-datatable-responsive-demo">
    <ng-template pTemplate="header">
        <tr>
            <th>
                <fa-icon [icon]='["far","calendar-alt"]' size="lg"></fa-icon>
            </th>
            <th>
                <fa-icon [icon]='["far","chair"]' size="lg"></fa-icon>
            </th>
            <th>
                <fa-icon [icon]='["far","badge-dollar"]' size="lg"></fa-icon>
            </th>
        </tr>
    </ng-template>
    <ng-template let-rec pTemplate="body">
        <tr (click)="onVisitSelect(rec)">
            <td>
                <span class="p-column-title">
                    <fa-icon [icon]='["far","calendar-alt"]' size="lg"></fa-icon>
                </span>
                {{app.moment(rec.visitDateTime).format('l LT')}}
            </td>
            <td>
                <span class="p-column-title">
                    <fa-icon [icon]='["far","chair"]' size="lg"></fa-icon>
                </span>
                <fa-icon [icon]='["far",rec.sourceObject.faIcon]' [pTooltip]="rec.sourceObject.displayName"></fa-icon>
                
            </td>
            <td>
                <span class="p-column-title">
                    <fa-icon [icon]='["far","badge-dollar"]' size="lg"></fa-icon>
                </span>
                {{rec.visitRevenue | currency}}
            </td>

        </tr>
    </ng-template>
</p-table>